/*  file: src/reducers/modal.js  
*          "reducers" are a part of REDUX state management system, using actions/reducers/state
*           Reducers are pure functions that take the a) current state of the application and 
*           b) a dispatched action as input and return a new state based on the action type and its associated data (payload). 
*          There is also a src/actions/modal.js
*          NOTE: using REDUX for modals is an old method and we need to think about a rewrite when possible
*/

import {
  SHOW_MODAL,
  HIDE_MODAL,
  UPDATE_MODAL_PROPS
} from '../actions/modal'

const initialState = {
  modalType: null,
  modalProps: {},
  visible: false
}

const modal = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        modalType: action.modalType,
        modalProps: action.modalProps,
        visible: true
      }
    case HIDE_MODAL:
      return initialState
    case UPDATE_MODAL_PROPS:
      return {
        ...state,
        modalProps: {
          ...state.modalProps,
          [action.field]: action.props
        }
      }
    default:
      return state
  }
}

export default modal
